export class GlobalConstants {
    public static widerrufButtonText = "Vertrag Widerrufen"
    public static errorMessageTranslations = {
        UsernameExistsException: "Der Nutzer existiert schon. Bitte melden Sie sich an.",
        UserNotFoundException: "Der Nutzer existiert nicht. Bitte registrieren sie sich.",
        ChallengeResponseCannotBeEmpty: "Der 6-stellige Code muss angegeben werden. Bitte überprüfen Sie ihre E-Mail."
    }
}